import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import ChecklistSelect from '../../../../containers/checklists/select/ChecklistSelect'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Textarea from '../../../../components/form/Textarea'
import ColorPicker from '../../../../packages/kiti/components/form/ColorPicker'
import DocumentInput from '../../../../components/form/DocumentInput'

const GeneralSection = () => {
  const { t } = useTranslation('editFormV2')

  return (
    <>
      <Separator weight={4} />
      <Grid paddingGutter={0.5} wrap>
        <Col width="50%" wrapOn="sm">
          <FormItem label={t('name')} field="name" />
        </Col>

        <Col width="50%" wrapOn="sm">
          <FormItem
            label={t('checklist')}
            field="checklist"
            Input={ChecklistSelect}
            filter={{ usages: ['form'] }}
            canCreate
          />
        </Col>

        <Col width="100%" wrapOn="sm">
          <FormItem label={t('description')} field="description" Input={Textarea} useMarkdown />
        </Col>
      </Grid>
    </>
  )
}

export default GeneralSection
